import {
    SpeechConfig,
    AudioConfig,
    SpeechRecognizer,
    AutoDetectSourceLanguageConfig,
} from "microsoft-cognitiveservices-speech-sdk";

const fetchSpeechConfig = async (): Promise<{ token: string; region: string; languages: string[] }> => {
    const response = await fetch("/api/speech");
    if (!response.ok) {
        throw new Error("Failed to fetch speech config");
    }
    return response.json();
};

export const multiLingualSpeechRecognizer = async (deviceId?: string): Promise<SpeechRecognizer> => {
    const { token, region, languages } = await fetchSpeechConfig();

    const speechConfig = SpeechConfig.fromAuthorizationToken(token, region);
    const audioConfig = deviceId
        ? AudioConfig.fromMicrophoneInput(deviceId)
        : AudioConfig.fromDefaultMicrophoneInput();

    try {
        const autoDetectConfig = AutoDetectSourceLanguageConfig.fromLanguages(languages);
        return SpeechRecognizer.FromConfig(speechConfig, autoDetectConfig, audioConfig);
    } catch {
        return new SpeechRecognizer(speechConfig, audioConfig);
    }
};
